import { render } from "./SnapshotZones.vue?vue&type=template&id=cca436be&scoped=true"
import script from "./SnapshotZones.vue?vue&type=script&lang=js"
export * from "./SnapshotZones.vue?vue&type=script&lang=js"

import "./SnapshotZones.vue?vue&type=style&index=0&id=cca436be&lang=less&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cca436be"]])

export default __exports__